import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class OrderTemplateService {
	constructor(private _http: HttpClient) {
	}

	/**
	 * @api {get} /v2/Orders/Templates/TemplateNameExists/:custId Check if Template Exists
	 * @apiName checkIfTemplateNameExists
	 * @apiParam {string} [templateName] Template Name
	 * @apiParam {number} custId Customer ID
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	checkIfTemplateNameExists<Boolean>(templateName, custId) {
		let params: HttpParams = new HttpParams();
		params = params.append('templateName', templateName);
		return this._http.get(`${environment.apiUrl}/v2/Orders/Templates/TemplateNameExists/${custId}`, {params});
	}

	/**
	 * @api {post} /v2/Orders/Templates Create Template
	 * @apiName createTemplate
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	createTemplate(template) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Orders/Templates`, template);
	}

	/**
	 * @api {delete} /v2/Orders/Templates/:id Delete Template
	 * @apiName deleteTemplate
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	deleteTemplate(id) {
		return this._http.delete<any>(`${environment.apiUrl}/v2/Orders/Templates/${id}`);
	}

	/**
	 * @api {post} /v2/Orders/Templates/:custId/Recent/:numberToGet Get Recent Templates
	 * @apiName getRecentTemplates
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	getRecentTemplates(custId, numberToGet, searchCriteria) {
		return this._http.post<any>(`${environment.apiUrl}/v2/Orders/Templates/${custId}/Recent/${numberToGet}`, JSON.stringify(searchCriteria));
	}

	/**
	 * @api {get} /v2/Orders/Templates/:id Get Template
	 * @apiName getTemplate
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	getTemplate(id) {
		return this._http.get<any>(`${environment.apiUrl}/v2/Orders/Templates/${id}`);
	}

	/**
	 * @api {post} /v2/Orders/Templates/:custId Get Templates
	 * @apiName getRecentTemplates
	 * @apiParam {number} [pageNum] Page Number
	 * @apiParam {number} [pageSize] Page Size
	 * @apiParam {boolean} [includeTotalCount] Whether to include total count
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	getTemplates(criteria, pageNum, pageSize, custId) {
		let params: HttpParams = new HttpParams();
		if (pageNum) {
			params = params.append('pageNum', pageNum);
		}
		if (pageSize) {
			params = params.append('pageSize', pageSize);
		}
		return this._http.post<any>(`${environment.apiUrl}/v2/Orders/Templates/${custId}`, JSON.stringify(criteria), {params});
	}

	/**
	 * @api {put} /v2/Orders/Templates/:id Update Template
	 * @apiName updateTemplate
	 * @apiGroup Orders
	 * @apiVersion 20.0.0
	 */
	updateTemplate(template, id) {
		return this._http.put<any>(`${environment.apiUrl}/v2/Orders/Templates/${id}`, template);
	}
}
